<script>
import SLSItemService from '@/services/SistemaDKP/SLSItem.service';
import SlsEmbalagService from '@/services/SistemaDKP/sls-embalag.service';
import Swal from 'sweetalert2';
import { mapActions, mapGetters } from 'vuex';
import { BModal, BSpinner } from 'bootstrap-vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import axios from '@/libs/axios';
import { getTotvsBaseUrl } from '@/utils/totvsApi';
import { IMAGEM_PADRAO, imagemProduto } from '@/utils/imagemUrl';
import SLSEstoqueService, { getTipoPedidoAtual } from '@/services/SistemaDKP/SLSEstoque.service';
import { isPerfilClienteAtivo, isPerfilRepresentanteAtivo, nomeCategoria } from '@/libs/perfilCliente';
import { aplicarPrecoDoacao, isPedidoDoacao } from '@/utils/impostoSimulador';
import { selecionarNaturezaFiscal } from '@/utils/naturezaFiscal';
import { precoFinalSimulado, precoTabelaSimulado } from '@/utils/precoProveniencia';
import { precoVisualizacao, ehValorDeCusto } from '@/utils/precoVisualizacao';
import { tipoPedidoSelecionadoParaEstoque } from '@/utils/estoqueVisibilidade';
import PicOfertaInline from '@/components/catalogo-produtos/PicOfertaInline.vue';

const slsItemService = new SLSItemService();
const slsEmbalagemService = new SlsEmbalagService();
const slsEstoqueService = new SLSEstoqueService();
export default {
  name: 'ModalSelectedEmbalagens',
  components: {
    PicOfertaInline,
    BModal,
    BSpinner,
    ECommerceProductDetails: () => import('@/views/app/CartECommerce/e-commerce-product-details/ECommerceProductDetails.vue'),
    InfoPedido: () => import('@/components/catalogo-produtos/InfoPedido.vue'),
  },
  data() {
    return {
      selected: null,
      show: false,
      gradeAtual: [],
      arrayEmbalagens: [],
      itemsCarrinho: [],
      isLoading: false,
      impostoLoading: false,
      impostoCalculado: null,
      produtosAdicionados: {},
      estoqueInfo: null,
      estoqueLoading: false,
      impostoPreview: null,
      impostoPreviewLoading: false,
      pricingRequestId: 0,
      pricingState: {
        status: 'idle',
        contextKey: null,
        itemId: null,
        effectivePrice: null,
        message: 'Aguardando cálculo do preço.',
      },
      adicionarLoading: false,
    };
  },

  computed: {
    totalVisualCarrinho() {
      const tipo = tipoPedidoSelecionadoParaEstoque(this.$store);
      let total = 0;
      for (const item of this.itemsCarrinho) {
        const preco = precoVisualizacao({ item, tipoPedido: item.categoria_tipo_pedido || tipo });
        if (preco === null) return null;
        total += preco * Number(item.pedido_item_quantidade);
      }
      return total;
    },
    valorDeCustoVisual() {
      return ehValorDeCusto(tipoPedidoSelecionadoParaEstoque(this.$store));
    },
    pedidoContextPic() {
      return this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
    },
    getInfoItem: {
      get() {
        return this.$store.getters['intensPedido/getFormData'];
      },
      set(value) {
        this.$store.commit('intensPedido/SET_DETALHES_ITEM', value);
      },
    },
    ...mapGetters('InfoPedido', [
      'GET_CLIENTE_DATA',
      'GET_ENDERECO_ENTREGA',
      'GET_DATA_CAPA_PEDIDO',
    ]),
    ...mapGetters('ItemStore', {
      json: 'GET_GRADE_ATUAL',
    }),
    ...mapGetters('ItemStore', {
      item: 'GET_CURRENT_ITEM',
    }),
    ...mapGetters('slsEmbalagem', {
      currentEmbalagem: 'getCurrentEsEmbalag',
    }),
    ...mapGetters('PedidosStore', {
      pedidoItens: 'getItemPedido',
    }),
    precoCalculadoAtualValido() {
      const snapshot = this.getPricingContextSnapshot();
      return this.pricingState.status === 'success'
        && this.pricingState.contextKey === snapshot.key
        && this.pricingState.itemId === snapshot.itemId
        && Number.isFinite(this.pricingState.effectivePrice)
        && this.pricingState.effectivePrice > 0;
    },
  },
  methods: {
    onPicItemsAdded(event) {
      if (event.type !== 'info-pedido' || !this.show
        || this.$store.getters['preferencias/picAtivo'] !== true) return;
      // PIC already committed to the cart. Do not discard pending normal items.
      if (!this.itemsCarrinho.length) this.$refs.refModalTopSelectedEmbalagens.hide();
    },
    usarPic(offer) {
      const itemid = this.getInfoItem?.dataItensPedido?.item_id;
      if (!this.show || this.$store.getters['preferencias/picAtivo'] !== true
        || !itemid || String(offer.itemid) !== String(itemid)) return;
      this.$root.$emit('openModal:pic', {
        type: 'info-pedido',
        operacao: 'create',
        data: null,
        itemid,
        picid: offer.picid,
      });
    },
    ...mapActions('intensPedido', [
      'itensMarcaPedido',
      'itensCategoriaPedido',
      'itensReferenciaPedido',
      'itensEmbalagemPedido',
      'itensdetalhes',
      'detalhesPedidoStored',
      'setListTabelaItens',
      'clearModalItens',
      'buscaCorGradeItens',
      'setIsLoadingReferencia',
      'setIsLoadingReferenciaRestante',
    ]),
    getPedidoFormSnapshot() {
      const userId = this.getUserId();
      let form;
      try {
        const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);
        if (savedFormData) form = JSON.parse(savedFormData);
      } catch (error) {
        console.warn('[ModalEmbalagens] dados locais do pedido inválidos:', error?.message);
      }
      form = form || this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO']
        || this.GET_CLIENTE_DATA
        || {};
      const atual = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      return {
        ...form,
        cliente: atual?.cliente?.clienteid === form?.cliente?.clienteid ? atual.cliente : form.cliente,
        estabelecimento: atual?.cliente?.clienteid === form?.cliente?.clienteid ? atual.estabelecimento : form.estabelecimento,
        enderecoAlternativo: this.$store.getters['InfoPedido/GET_ENDERECO_ALTERNATIVO'],
      };
    },
    getPricingContextSnapshot(resolvedItem = null) {
      const itemSelected = resolvedItem
        || this.getInfoItem?.dataItensPedido
        || this.$store.getters['InfoPedido/GET_ITEM_SELECTED']
        || {};
      const form = this.getPedidoFormSnapshot();
      const endereco = form.enderecoAlternativo
        ? { ufid: form.enderecoAlternativo.uf, clienteenderecocidade: form.enderecoAlternativo.cidade }
        : (form.enderecoEntrega || this.GET_ENDERECO_ENTREGA || {});
      const itemId = itemSelected.item_id || itemSelected.CodItem || itemSelected.itemId || null;
      const values = [
        itemId,
        itemSelected.item_price ?? itemSelected.preco ?? itemSelected.PrecoUnitario ?? null,
        form.estabelecimento?.estabelecimentoid,
        form.cliente?.clienteid,
        form.cliente?.clienteiderp ?? form.cliente?.clienteIderp,
        form.cliente?.clientenomeabreviado ?? form.cliente?.clientenomematriz,
        form.cliente?.clientenatoperinterna,
        form.cliente?.clientenatoperexterna,
        form.estabelecimento?.ufid,
        form.canalVenda?.canal_venda_id ?? form.cliente?.canalvendaid ?? form.cliente?.canal_venda_id,
        form.tabelaPreco?.tabelapreco_id,
        form.condicaoPagamento?.condicaopagamentoid,
        form.cliente?.clienteisentoie,
        endereco.ufid,
        endereco.clienteenderecocidade,
        getTipoPedidoAtual(),
      ];
      return { itemId, form, endereco, key: JSON.stringify(values) };
    },
    getEffectiveCalculatedPrice(preview) {
      const preco = precoFinalSimulado(preview);
      if (Number.isFinite(preco) && preco > 0) return preco;
      return null;
    },
    invalidatePricing(message = 'Aguardando cálculo do preço.') {
      this.pricingRequestId += 1;
      this.impostoPreview = null;
      this.impostoPreviewLoading = false;
      this.pricingState = {
        status: 'idle',
        contextKey: null,
        itemId: null,
        effectivePrice: null,
        message,
      };
    },
    setPricingFailure(status, snapshot, message) {
      this.impostoPreview = null;
      this.pricingState = {
        status,
        contextKey: snapshot?.key || null,
        itemId: snapshot?.itemId || null,
        effectivePrice: null,
        message,
      };
    },
    notifyPricingUnavailable() {
      const text = this.pricingState.status === 'loading'
        ? 'O preço deste produto ainda está sendo calculado. Aguarde e tente novamente.'
        : (this.pricingState.message || 'Não foi possível calcular o preço atual. Tente novamente.');
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Preço não confirmado',
          text,
          icon: 'AlertTriangleIcon',
          variant: 'warning',
        },
      });
    },
    retryPricing() {
      const item = this.getInfoItem?.dataItensPedido;
      if (item?.item_id) this.fetchEstoqueEImpostoPreview(item);
    },
    isPricingSnapshotCurrent(contextKey, itemId) {
      const current = this.getPricingContextSnapshot();
      return this.pricingState.status === 'success'
        && this.pricingState.contextKey === contextKey
        && this.pricingState.contextKey === current.key
        && this.pricingState.itemId === itemId
        && current.itemId === itemId
        && Number.isFinite(this.pricingState.effectivePrice)
        && this.pricingState.effectivePrice > 0;
    },
    async fetchEstoqueEImpostoPreview(resolvedItem = null) {
      // Prefere o item já resolvido (com item_id + item_price); cai no GET_ITEM_SELECTED se não houver.
      const itemSelected = resolvedItem
        || this.getInfoItem?.dataItensPedido
        || this.$store.getters['InfoPedido/GET_ITEM_SELECTED'];
      const itemId = itemSelected?.item_id || itemSelected?.CodItem || itemSelected?.itemId;
      console.log('[ModalEmbalagens] fetchEstoqueEImpostoPreview item:', itemId, itemSelected);
      let snapshot = this.getPricingContextSnapshot(itemSelected);
      const requestId = ++this.pricingRequestId;
      if (!itemId) {
        this.estoqueLoading = false;
        this.impostoPreviewLoading = false;
        this.setPricingFailure('error', snapshot, 'Produto sem SKU válido para calcular o preço.');
        return;
      }

      this.estoqueInfo = null;
      this.impostoPreview = null;
      this.estoqueLoading = true;
      this.impostoPreviewLoading = true;
      this.pricingState = {
        status: 'loading',
        contextKey: snapshot.key,
        itemId,
        effectivePrice: null,
        message: 'Calculando o preço atual deste produto…',
      };

      // O primeiro item define WS/WC para Cliente. Resolva antes da simulação:
      // trocar o tipo só no Adicionar invalidava o preço na primeira tentativa.
      if (isPerfilClienteAtivo()
        && !(this.$store.getters['PedidosStore/getItemPedido'] || []).length) {
        try {
          const { data } = await axios.post('items/categorias', {
            itemIds: [itemId], clienteid: snapshot.form.cliente?.clienteid,
          }, { timeout: 30000 });
          if (requestId !== this.pricingRequestId
            || this.getPricingContextSnapshot().key !== snapshot.key) return;
          const flags = (data?.flags?.[itemId] || []).map(f => String(f).toUpperCase());
          const tipo = flags.includes('WC') ? 'WC' : (flags.includes('WS') ? 'WS' : '');
          if (!tipo) throw new Error('Categoria do produto não identificada.');
          // Um carrinho preenchido enquanto a consulta estava pendente não pode
          // ter sua categoria sobrescrita por esta resposta.
          if (!(this.$store.getters['PedidosStore/getItemPedido'] || []).length) {
            const atual = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO']?.tipoPedidoCliente?.tipopedidoid;
            if (String(atual || '').toUpperCase() !== tipo) {
              const opc = (this.$store.getters['InfoPedido/GET_TIPO_PEDIDOS_CLIENTE'] || [])
                .find(t => String(t?.value || '').toUpperCase() === tipo);
              this.$store.commit('InfoPedido/SET_TIPO_PEDIDO_CLIENTE', {
                tipopedidoid: tipo, tipopedidodescricao: opc?.text || nomeCategoria(tipo),
              });
            }
          }
          snapshot = this.getPricingContextSnapshot(itemSelected);
          this.pricingState.contextKey = snapshot.key;
        } catch (e) {
          if (requestId === this.pricingRequestId
            && this.getPricingContextSnapshot().key === snapshot.key) {
            this.setPricingFailure('error', snapshot, 'Não foi possível confirmar a categoria do produto. Tente novamente.');
          }
          return;
        } finally {
          if (requestId === this.pricingRequestId) {
            this.estoqueLoading = false;
            this.impostoPreviewLoading = false;
          }
        }
        this.estoqueLoading = true;
        this.impostoPreviewLoading = true;
      }

      // Estoque (TOTVS /apiSaldoEstoqSF via backend) — bypassa cache da sessão.
      // Tipo de pedido (WD/doação → depósito DOA; demais → LUI/LUN) — resolução
      // compartilhada com o serviço de estoque (cobre Home e Operações).
      const tipoPedidoId = getTipoPedidoAtual();
      axios.post(
        'estoque/consultar',
        { itemIds: [itemId], ...(tipoPedidoId ? { tipoPedidoId } : {}) },
        { timeout: 30000 },
      )
        .then(({ data }) => {
          if (requestId !== this.pricingRequestId
            || this.getPricingContextSnapshot().key !== snapshot.key) return;
          console.log('[ModalEmbalagens] estoque resp:', data);
          this.estoqueInfo = data?.data?.[itemId] || { quantidade: null, fonte: 'sem-resposta' };
        })
        .catch((e) => {
          if (requestId !== this.pricingRequestId
            || this.getPricingContextSnapshot().key !== snapshot.key) return;
          console.warn('[ModalEmbalagens] estoque erro:', e?.response?.status, e?.response?.data || e?.message);
          this.estoqueInfo = { quantidade: null, fonte: 'erro' };
        })
        .finally(() => {
          if (requestId === this.pricingRequestId) this.estoqueLoading = false;
        });

      // Imposto preview (TOTVS /pwSimulaImpostoSF via backend)
      try {
        // Lê SEMPRE do localStorage do form do pedido — fonte mais completa de canalVenda etc.
        const form = snapshot.form;
        const enderecoEntrega = snapshot.endereco;

        const ctx = {
          estabelecimentoid: form.estabelecimento?.estabelecimentoid,
          // Alguns clientes (ex.: pessoa física) vêm do ERP sem clientenomeabreviado,
          // mas com o nome abreviado preenchido em clientenomematriz. Usa como fallback
          // para o c-pr-nome-abrev exigido pela TOTVS (pwSimulaImpostoSF).
          clientenomeabreviado: form.cliente?.clientenomeabreviado || form.cliente?.clientenomematriz || form.cliente?.clienteiderp || form.cliente?.clienteIderp,
          naturezaoperacaoid: selecionarNaturezaFiscal(form, { endereco: enderecoEntrega }),
          canalvendaid: form.canalVenda?.canal_venda_id || form.cliente?.canalvendaid || form.cliente?.canal_venda_id,
          clienteisentoie: form.cliente?.clienteisentoie,
          tabelaprecoid: form.tabelaPreco?.tabelapreco_id,
          condicaopagamentoid: form.condicaoPagamento?.condicaopagamentoid,
        };

        console.log('[ModalEmbalagens] imposto ctx:', ctx, 'endereco:', enderecoEntrega);

        const faltando = [];
        if (!ctx.estabelecimentoid) faltando.push('estabelecimento');
        if (!ctx.clientenomeabreviado) faltando.push('cliente');
        if (!ctx.tabelaprecoid) faltando.push('tabelaPreco');
        if (this.$store.getters['preferencias/condicaoPagamentoAtiva'] && !ctx.condicaopagamentoid) faltando.push('condicaoPagamento');
        if (!ctx.canalvendaid) faltando.push('canalVenda');
        if (faltando.length) {
          console.warn('[ModalEmbalagens] imposto pulado — selecione no pedido:', faltando.join(', '));
          if (requestId === this.pricingRequestId
            && this.getPricingContextSnapshot().key === snapshot.key) {
            this.setPricingFailure(
              'error',
              snapshot,
              `Selecione ${faltando.join(', ')} no pedido para calcular o preço.`,
            );
          }
          return;
        }

        const precoBase = parseFloat(itemSelected.item_price || itemSelected.preco || itemSelected.PrecoUnitario || 0);
        const { data: resp } = await axios.post(
          'imposto/simular',
          {
            estabelecimentoid: ctx.estabelecimentoid,
            clienteId: form.cliente?.clienteid,
            clienteNomeAbreviado: ctx.clientenomeabreviado,
            naturezaOperacaoId: ctx.naturezaoperacaoid,
            canalVendaId: ctx.canalvendaid,
            itemId,
            quantidade: 1,
            precoUnitario: precoBase,
            ufDs: enderecoEntrega?.ufid,
            cidadeDs: enderecoEntrega?.clienteenderecocidade,
            contribuinteIcms: ctx.clienteisentoie ? 0 : 1,
            tabelaPrecoId: ctx.tabelaprecoid,
            condicaoPagamentoId: ctx.condicaopagamentoid,
          },
          { timeout: 30000 },
        );
        if (requestId !== this.pricingRequestId
          || this.getPricingContextSnapshot().key !== snapshot.key) return;
        console.log('[ModalEmbalagens] imposto resp:', resp);
        // Pedido de doação (WD): usa d-preco-doacao quando disponível.
        const preview = aplicarPrecoDoacao(resp?.data || null, isPedidoDoacao(form), getTipoPedidoAtual()) || null;
        const effectivePrice = this.getEffectiveCalculatedPrice(preview);
        if (effectivePrice === null) {
          this.setPricingFailure(
            'error',
            snapshot,
            'O cálculo retornou sem preço. Revise os dados do pedido e tente novamente.',
          );
          if (precoFinalSimulado(preview) === 0) this.impostoPreview = preview;
          return;
        }
        this.impostoPreview = preview;
        this.pricingState = {
          status: 'success',
          contextKey: snapshot.key,
          itemId,
          effectivePrice,
          tablePrice: precoTabelaSimulado(preview),
          message: '',
        };
      } catch (e) {
        if (requestId !== this.pricingRequestId
          || this.getPricingContextSnapshot().key !== snapshot.key) return;
        console.warn('[ModalEmbalagens] imposto preview erro:', e?.response?.status, e?.response?.data || e?.message);
        this.setPricingFailure(
          'error',
          snapshot,
          'Não foi possível calcular o preço atual. Tente novamente.',
        );
      } finally {
        if (requestId === this.pricingRequestId) this.impostoPreviewLoading = false;
      }
    },

    async onSelectedEmbalagem() {
      this.show = true;
      this.isLoading = true;
      this.itemsCarrinho = [];
      this.impostoCalculado = null;
      this.estoqueInfo = null;
      this.invalidatePricing('Aguardando os dados do produto para calcular o preço.');

      try {
        let formData = this.$store.getters['InfoPedido/GET_VALIDATION_FORM_INFO_PEDIDO'];

        if (!formData) {
          const userId = this.getUserId();
          const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);

          if (savedFormData) {
            const parsedData = JSON.parse(savedFormData);

            this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', parsedData);

            this.$store.commit('InfoPedido/SET_CLIENTE_DATA', {
              clienteData: parsedData,
              enderecoEntrega: parsedData.enderecoEntrega,
              dataCapaPedido: {
                estabelecimentoid: parsedData.estabelecimento.estabelecimentoid,
                clientenomeabreviado: parsedData.cliente.clientenomeabreviado,
                naturezaoperacaoid: parsedData.naturezaOperacao?.naturezaoperacaoid || '',
                canal_venda_id: parsedData.canalVenda?.canal_venda_id || '',
                clienteisentoie: parsedData.cliente.clienteisentoie,
                tabelaprecoid: parsedData.tabelaPreco.tabelapreco_id,
                condicaopagamentoid: parsedData.condicaoPagamento.condicaopagamentoid,
              },
            });

            formData = true;
          } else {
            this.$refs.refModalTopSelectedEmbalagens.hide();
            await this.$bvModal.show('modal-center-info-pedido');
            return;
          }
        }

        this.$store.commit('InfoPedido/SET_IS_LOADING', false);

        const embalagensValues = this.$store.getters['slsEmbalagem/getEsEmbalg'];

        const itemSelected = this.$store.getters['InfoPedido/GET_ITEM_SELECTED'];
        const cliente = this.$store.getters['InfoPedido/GET_CLIENT_ID_ERP'];

        const tabelaPrecoId = this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM']?.tabelapreco_id
          || this.GET_DATA_CAPA_PEDIDO?.tabelaprecoid
          || null;
        const itemId = itemSelected?.item_id || itemSelected?.itemId || itemSelected?.CodItem;
        const familiaComercialId = itemSelected?.familia_comercial_id
          ?? itemSelected?.familiaComercialId ?? itemSelected?.referencia ?? 0;
        const itemImagem = {
          codMarca: itemSelected.cod_marca ?? itemSelected.codMarca ?? 'none',
          codCateg: itemSelected.cod_categ ?? itemSelected.codCateg ?? 'none',
          tabelaprecoId: tabelaPrecoId,
          clienteIderp: cliente?.clienteiderp,
          familiaComercialId,
          itemId,
        };

        // Exact Home/operation rows use the stored-detail endpoint with the
        // SKU query parameter.  It deliberately accepts 0/none placeholders
        // for optional family metadata; the SKU is never replaced by a family
        // id.  Keep the legacy infoItem request for old family-only rows.
        const resposta = itemId
          ? await this.detalhesPedidoStored({
            familiaComercialId: itemImagem.familiaComercialId,
            precoId: tabelaPrecoId || 0,
            codMarca: itemImagem.codMarca,
            codCateg: itemImagem.codCateg,
            itemId: itemSelected.item_id || itemId,
          })
          : await this.itensdetalhes(itemImagem);

        if (itemId && resposta) {
          const resolved = resposta?.Result?.Result
            || resposta?.Result
            || resposta?.data?.Result
            || resposta?.data
            || resposta;
          const exactItem = resolved?.item || {};
          const tabela = Array.isArray(resolved?.tabelaPreco) ? resolved.tabelaPreco[0] : null;
          const familia = Array.isArray(resolved?.familiaComercial)
            ? resolved.familiaComercial[0] : null;
          const current = this.getInfoItem?.dataItensPedido || {};
          const itemDescricao = itemSelected.item_descricao || itemSelected.itemDescricao
            || exactItem.item_descricao || exactItem.itemDescricao
            || resolved?.item_descricao || resolved?.itemDescricao
            || itemSelected.Descricao || familia?.Referencia || '';
          const resolvedPrice = Number(itemSelected.item_price) > 0
            ? itemSelected.item_price
            : (tabela?.tabelapreco_item_preco ?? tabela?.preco ?? exactItem.preco);
          const resolvedBasePrice = Number(itemSelected.item_price_base) > 0
            ? itemSelected.item_price_base
            : (tabela?.tabelapreco_item_preco ?? tabela?.preco ?? exactItem.preco);
          const resolvedItem = {
            ...current,
            ...itemSelected,
            ...(resolved?.dataItensPedido || {}),
            item_id: itemId,
            itemId,
            item_descricao: itemDescricao,
            itemDescricao,
            Descricao: itemSelected.Descricao || itemDescricao,
            item_name: itemSelected.item_name || itemDescricao
              || resolved?.item_name || familia?.Referencia,
            item_price: resolvedPrice,
            item_price_base: resolvedBasePrice,
            imagens: Array.isArray(itemSelected.imagens) && itemSelected.imagens.length
              ? itemSelected.imagens : (resolved?.imagens || []),
            cod_marca: itemSelected.cod_marca ?? itemSelected.codMarca
              ?? exactItem.cod_marca ?? resolved?.Marca?.[0]?.cod_marca,
            referencia: itemSelected.referencia ?? familia?.CodReferencia,
            familia_comercial_id: itemSelected.familia_comercial_id
              ?? exactItem.familia_comercial_id ?? familia?.CodReferencia,
            gradeItem: current.gradeItem || [],
          };
          this.$store.commit('intensPedido/SET_DETALHES_ITEM', resolvedItem);
        }

        if (resposta?.success === false) {
          this.$refs.refModalTopSelectedEmbalagens.hide();
          await Swal.fire({
            icon: 'warning',
            title: 'Não encontrado',
            text: resposta.message,
          });
        }

        if (!resposta) {
          this.$refs.refModalTopSelectedEmbalagens.hide();
          await Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: resposta?.message || 'Nenhum detalhe encontrado.',
          });
        } else {
          console.log('ITEM ENCONTRADO');
          const newGradeAtual = {
            embalagens: [],
          };
          this.gradeAtual = [];
          for (const embalagemValue of embalagensValues || []) {
            // console.log('itemSelected.cod_marca', itemSelected)
            console.log(itemSelected.cod_marca && itemSelected.cod_categ
              && tabelaPrecoId && itemSelected.familia_comercial_id);
            const hasRequiredData = !!itemId || (
              itemSelected.cod_marca !== null && itemSelected.cod_marca !== undefined
              && itemSelected.cod_categ !== null && itemSelected.cod_categ !== undefined
              && !!tabelaPrecoId
              && itemSelected.familia_comercial_id !== null && itemSelected.familia_comercial_id !== undefined
            );
            if (hasRequiredData) {
              console.log(
                'entrou no if',
              );
              /* PARA REQUISIÇÃO GET */
              const item = {
                codMarca: itemSelected.cod_marca,
                codCateg: itemSelected.cod_categ,
                tabelaprecoId: tabelaPrecoId,
                clienteIderp: cliente.clienteiderp,
                familiaComercialId: itemSelected.familia_comercial_id,
                cdnEmbalagem: embalagemValue.cdn_embalagem,
                codEmbal: embalagemValue.cdn_embalagem,
              };
              /* PARA REQUISIÇÃO POST */
              // const requestBody = {
              //   familiaComercialId: itemSelected.familia_comercial_id,
              //   codEmbal: embalagemValue.cdn_embalagem,
              //   codemitente: cliente.clienteiderp,
              //   nrtabpreco: 'BR24A'
              // };
              newGradeAtual.embalagens.push({
                descricao_embalagem: embalagemValue.des_embalag,
                cdn_embalagem: embalagemValue.cdn_embalagem,
                grade: null,
                itemMultiplo: 0,
              });
            }
            this.gradeAtual.push(newGradeAtual);

            // console.log('GRADE ATUAL', this.gradeAtual);
          }

          this.$store.commit('ItemStore/SET_CURRENT_ITEM', this.getInfoItem.dataItensPedido);
          // this.$refs.refModalTopSelectedEmbalagens.hide()
          // this.$bvModal.show('modal-info-produto-id')
          this.selected = null;

          // Agora que temos o item resolvido com item_id + item_price, dispara estoque + imposto
          this.fetchEstoqueEImpostoPreview(this.getInfoItem.dataItensPedido);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async adicionarCarrinho() {
      if (this.adicionarLoading) return;
      const pricingAtEntry = this.getPricingContextSnapshot();
      if (!this.isPricingSnapshotCurrent(pricingAtEntry.key, pricingAtEntry.itemId)) {
        this.notifyPricingUnavailable();
        this.retryPricing();
        return;
      }
      this.adicionarLoading = true;
      try {
        const itemQtd = this.itemsCarrinho.filter((item) => item.pedido_item_quantidade > 0);
        if (itemQtd.some((item) => item.item_id !== pricingAtEntry.itemId
          || item.pedido_item_preco_unitario !== this.pricingState.effectivePrice)) {
          this.notifyPricingUnavailable();
          return;
        }

        // Bloqueio de venda sem estoque: preferência ligada OU perfil Representante
        // (representante NUNCA pode vender sem estoque, independente da preferência).
        // Cliente NUNCA é bloqueado: excedente vira backorder e é atendido depois.
        const bloqueioEstoqueAtivo = itemQtd.length
          && !isPerfilClienteAtivo()
          && (this.$store.getters['preferencias/bloquearVendaSemEstoque'] || isPerfilRepresentanteAtivo());
        if (bloqueioEstoqueAtivo && this.estoqueInfo && this.estoqueInfo.quantidade !== 'INF') {
          const semInfo = this.estoqueInfo.quantidade === null
            || this.estoqueInfo.quantidade === undefined;
          if (semInfo) {
            // "Sem info" = estoque desconhecido → com o bloqueio ativo, trata
            // como indisponível (mesma regra do "Sem estoque").
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Estoque indisponível',
                text: 'Não foi possível confirmar o estoque deste produto. Não é permitido adicioná-lo ao pedido.',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            });
            return;
          }
          const totalSolicitado = itemQtd.reduce(
            (acc, it) => acc + (Number(it.pedido_item_quantidade) || 0),
            0,
          );
          const disponivel = Number(this.estoqueInfo.quantidade) || 0;
          if (totalSolicitado > disponivel) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Estoque insuficiente',
                text: `${isPerfilClienteAtivo() || (isPerfilRepresentanteAtivo() && disponivel > 50)
                  ? 'Estoque insuficiente.'
                  : `Disponível: ${disponivel} un.`} Solicitado: ${totalSolicitado} un. Ajuste a quantidade para prosseguir.`,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            });
            return;
          }
        }

        // ── Regra Cliente WS/WC ────────────────────────────────────────────────
        // Perfil Cliente: um pedido tem UMA categoria só (WS ou WC).
        // 1. Consulta a categoria_tipo_pedido REAL de cada item via API.
        // 2. Carrinho vazio → primeiro item define a categoria do pedido
        //    (ajusta tipoPedidoCliente no store).
        // 3. Carrinho com itens → novo item deve ser da MESMA categoria;
        //    se for diferente, mostra alerta claro e NÃO adiciona (return).
        // ───────────────────────────────────────────────────────────────────
        const perfilCliente = isPerfilClienteAtivo();
        let categoriaResolvida = ''; // categoria que será usada ao gravar categoria_tipo_pedido
        let categoriasPorItem = {};
        if (perfilCliente && itemQtd.length) {
          // Busca categorias reais dos itens (flags por item_id)
          let flagsMap = {};
          try {
            const ids = [...new Set(itemQtd.map((i) => i.item_id).filter(Boolean))];
            const clienteidSel = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO']
              ?.cliente?.clienteid;
            const { data: catResp } = await axios.post('items/categorias', { itemIds: ids, clienteid: clienteidSel });
            flagsMap = catResp?.flags || {};
          } catch (e) {
            console.warn('[ModalEmbalagens] categorias dos itens indisponíveis:', e?.message);
            Swal.fire({
              icon: 'warning',
              title: 'Categoria indisponível',
              text: 'Não foi possível confirmar se os produtos são Padrão ou Certificação. Tente novamente antes de adicioná-los ao pedido.',
            });
            return;
          }

          // Resolve TODOS os itens do lote. WC tem precedência quando o ERP
          // também deixa flagvendavel ativa, igual ao endpoint de catálogo.
          categoriasPorItem = {};
          itemQtd.forEach((item) => {
            const flags = (flagsMap[item.item_id] || []).map((f) => String(f).toUpperCase());
            categoriasPorItem[item.item_id] = flags.includes('WC')
              ? 'WC'
              : (flags.includes('WS') ? 'WS' : '');
          });
          const semCategoria = itemQtd.filter((item) => !categoriasPorItem[item.item_id]);
          if (semCategoria.length) {
            Swal.fire({
              icon: 'warning',
              title: 'Categoria não identificada',
              text: 'Um ou mais produtos não possuem categoria Padrão ou Certificação confirmada e não podem ser adicionados a este pedido.',
            });
            return;
          }
          const categoriasNovas = [...new Set(Object.values(categoriasPorItem).filter(Boolean))];
          if (categoriasNovas.length > 1) {
            Swal.fire({
              icon: 'warning',
              title: 'Categorias diferentes',
              text: 'Os produtos selecionados misturam Padrão e Certificação. Adicione somente produtos da mesma categoria neste pedido.',
            });
            return;
          }
          const catItem = categoriasNovas[0] || '';

          // Categoria atual do pedido = itens já no carrinho (fonte de verdade)
          // ou tipoPedidoCliente do store se carrinho ainda vazio.
          const itensNoCarrinho = this.$store.getters['PedidosStore/getItemPedido'] || [];
          const categoriaCarrinho = itensNoCarrinho.length > 0
            ? String(itensNoCarrinho[0].categoria_tipo_pedido || '').toUpperCase()
            : String(
              this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO']
                ?.tipoPedidoCliente?.tipopedidoid || '',
            ).toUpperCase();

          if (catItem) {
            if (itensNoCarrinho.length === 0) {
              // Carrinho vazio: primeiro item define a categoria do pedido
              categoriaResolvida = catItem;
              if (categoriaCarrinho !== catItem) {
                // Ajusta tipoPedidoCliente no store para a categoria do item
                const lista = this.$store.getters['InfoPedido/GET_TIPO_PEDIDOS_CLIENTE'] || [];
                const opc = lista.find((t) => String(t?.value || '').toUpperCase() === catItem);
                // A lista é carregada de forma assíncrona. O tipo real do item
                // não pode depender dela estar pronta: grava WS/WC diretamente
                // e usa a opção apenas para enriquecer a descrição.
                this.$store.commit('InfoPedido/SET_TIPO_PEDIDO_CLIENTE', {
                  tipopedidoid: opc?.value || catItem,
                  tipopedidodescricao: opc?.text || nomeCategoria(catItem),
                });
                console.info(`[ModalEmbalagens] Carrinho vazio — categoria do pedido definida pelo primeiro item: ${catItem}`);
              }
            } else if (categoriaCarrinho && catItem !== categoriaCarrinho) {
              // Carrinho com itens: categoria diferente → bloqueia e NÃO adiciona
              Swal.fire({
                icon: 'warning',
                title: 'Categoria diferente',
                text: `O produto "${itemQtd[0].item_descricao || itemQtd[0].item_id}" é da categoria ${nomeCategoria(catItem)}, `
                  + `diferente da categoria deste pedido (${nomeCategoria(categoriaCarrinho)}). `
                  + 'Finalize este pedido e faça um novo pedido da categoria correta para incluí-lo.',
              });
              return; // NÃO muda o carrinho
            } else {
              categoriaResolvida = catItem || categoriaCarrinho;
            }
          } else {
            // Sem flags da API: usa categoria corrente (melhor esforço)
            categoriaResolvida = categoriaCarrinho;
          }
        }

        if (itemQtd.length) {
          // Categorias são buscadas acima de forma assíncrona. Preço/contexto podem
          // ter mudado enquanto aguardávamos; valide novamente imediatamente antes
          // de qualquer commit no carrinho.
          if (!this.isPricingSnapshotCurrent(pricingAtEntry.key, pricingAtEntry.itemId)) {
            this.notifyPricingUnavailable();
            this.retryPricing();
            return;
          }
          for (const item of itemQtd) {
            console.log('ITEM ENVIADOS AO CARRINHO', item);

            if (perfilCliente) {
              // Grava categoria_tipo_pedido REAL do item (badge do carrinho).
              item.categoria_tipo_pedido = categoriasPorItem[item.item_id]
                || categoriaResolvida || item.categoria_tipo_pedido || '';
            }

            const existingItem = this.$store.getters['PedidosStore/getItemPedido'].find(
              (cartItem) => cartItem.item_id === item.item_id
                && cartItem.cdn_cor === item.cdn_cor
                && cartItem.cdn_tamanho === item.cdn_tamanho
                && cartItem.cdn_embalag === item.cdn_embalag
                && cartItem.familia_comercial_id === item.familia_comercial_id,
            );

            if (existingItem) {
              // Se o produto já existe, atualiza apenas a quantidade
              this.$store.commit('PedidosStore/UPDATE_ITEM_QUANTITY', {
                item: existingItem,
                quantity: existingItem.pedido_item_quantidade + item.pedido_item_quantidade,
              });
            } else {
              // Adiciona como novo item
              this.$store.commit('PedidosStore/ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', {
                ...item,
                pedido_item_seq: this.$store.getters['PedidosStore/getLastSequenceItemPedido'] + 10,
              });
            }
          }
          // this.$store.commit('ECommercerStore/ADD_OR_UPDATE_PRODUCT_TO_CART', {
          //   ...this.item,
          //   item_price: parseFloat(this.item.item_price),
          //   quantidade: 1
          // })
          this.$refs.refModalTopSelectedEmbalagens.hide();
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Falha',
              text: 'Obrigatorio Adicionar ao Menos um Produto.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.adicionarLoading = false;
      }
    },
    onCancelModal() {
      this.mainImg = IMAGEM_PADRAO;
      this.$refs.refModalTopSelectedEmbalagens.hide();
    },
    onModalHidden() {
      this.show = false;
      this.invalidatePricing('Reabra o produto para calcular o preço.');
      this.itemsCarrinho = [];
      this.estoqueInfo = null;
      this.estoqueLoading = false;
      this.adicionarLoading = false;
    },
    onInfoPedidoUpdated() {
      this.invalidatePricing('Os dados do pedido mudaram. Recalculando o preço…');
      this.itemsCarrinho = [];
      this.retryPricing();
    },
    handleRemoveItem(item) {
      console.log('REMOVENDO ITEM', item);
      this.itemsCarrinho = this.itemsCarrinho.filter((i) => i.item_id !== item.item_id && i.pedido_item_quantidade !== item.valor);
      console.log('CARRINHO ATUAL', this.itemsCarrinho);
    },

    updatedGrade(value) {
      console.log('updatedGradeItens', value);
      const pricing = this.getPricingContextSnapshot();
      if (!this.isPricingSnapshotCurrent(pricing.key, pricing.itemId)
        || value.some((gradeItem) => gradeItem.item_id !== pricing.itemId)) {
        this.itemsCarrinho = [];
        this.notifyPricingUnavailable();
        return;
      }
      const effectivePrice = this.pricingState.effectivePrice;
      const currentItem = this.item || this.getInfoItem?.dataItensPedido || {};
      this.itemsCarrinho = value.map((item, index) => {
        console.log('THIS ITEM', currentItem);
        // const imagem = this.item.imagens.find(img => img.cdnCor === item.cdn_cor)
        const detalhe = this.getInfoItem?.dataItensPedido;
        const caminhoImagemPrincipal = imagemProduto(
          String(detalhe?.item_id) === String(pricing.itemId) ? detalhe : currentItem,
        );
        const precoBase = parseFloat(currentItem.item_price_base ?? currentItem.item_price);
        const previewComImposto = this.impostoPreview
          && this.impostoPreview.precoComImposto !== undefined
          && this.impostoPreview.precoComImposto !== null
          && Number(this.impostoPreview.precoComImposto) > 0
          ? parseFloat(this.impostoPreview.precoComImposto)
          : null;
        // Nunca use preço bruto/da grade/base como autorização para compra. O
        // valor vem exclusivamente do cálculo bem-sucedido deste contexto/SKU.
        const precoComImpostoItem = effectivePrice;
        // preço BRUTO (d-pr-unitario) — referência exibida riscada no carrinho
        const precoBrutoItem = (item.precoBruto !== undefined
          && item.precoBruto !== null
          && Number(item.precoBruto) > 0)
          ? parseFloat(item.precoBruto)
          : previewComImposto;

        return {
          index: this.pedidoItens.length + 1,
          cod_marca: currentItem.cod_marca,
          familia_comercial_id: currentItem.familia_comercial_id
            ?? currentItem.referencia ?? null,
          familia_comercial_descricao: currentItem.item_name,
          cdn_cor: item.cdn_cor,
          cdn_tamanho: item.cdn_tamanho,
          des_tamanho: item.tamanho,
          des_cor: item.des_cor,
          item_id: item.item_id,
          item_descricao: currentItem.item_descricao || currentItem.itemDescricao
            || `${item.item_id} - ${currentItem.item_name || ''}`.trim(),
          // item_imagem: imagem ? imagem.caminho : 'https://dkpsales-novo-hanes.s3.amazonaws.com/images/images/produto-sem-imagem.png',
          item_imagem: caminhoImagemPrincipal,
          pedido_item_seq: this.$store.getters['PedidosStore/getLastSequenceItemPedido'] + 10,
          pic_id: 0,
          marca: currentItem.item_marca,
          embalagem: item.embalagem,
          cdn_embalag: item.cdn_embalag,
          pedido_item_preco_unitario: precoComImpostoItem,
          pedido_item_preco_tabela_erp: this.pricingState.tablePrice,
          pedido_item_preco_unitario_base: precoBase,
          pedido_item_quantidade: parseInt(item.valor, 10),
          valor_total: +(precoComImpostoItem * parseFloat(item.valor)),
          pedido_item_preco_total: +(precoComImpostoItem * parseFloat(item.valor)),
          precoComImposto: precoComImpostoItem,
          precoBruto: precoBrutoItem,
          baseIcms: item.baseIcms,
          valorIcms: item.valorIcms,
          naturezaoperacaoidimposto: item.naturezaoperacaoidimposto,
          cliente: this.GET_CLIENTE_DATA.cliente.clientenomeabreviado,
          itemMultiplo: item.itemMultiplo,
        };
      });
      console.log('itemsCarrinho', this.itemsCarrinho);
    },
    async calcularImposto(newItem) {
      try {
        let clienteData = this.GET_CLIENTE_DATA;
        let enderecoEntrega = this.GET_ENDERECO_ENTREGA;
        let dataCapa = this.GET_DATA_CAPA_PEDIDO;

        if (!clienteData || !clienteData.estabelecimento) {
          const userId = this.getUserId();
          const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);

          if (savedFormData) {
            const parsedData = JSON.parse(savedFormData);

            this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', parsedData);

            clienteData = parsedData;
            enderecoEntrega = parsedData.enderecoEntrega;
            dataCapa = {
              estabelecimentoid: parsedData.estabelecimento.estabelecimentoid,
              clientenomeabreviado: parsedData.cliente.clientenomeabreviado,
              naturezaoperacaoid: parsedData.naturezaOperacao?.naturezaoperacaoid || '',
              canal_venda_id: parsedData.canalVenda?.canal_venda_id || '',
              clienteisentoie: parsedData.cliente.clienteisentoie,
              tabelaprecoid: parsedData.tabelaPreco.tabelapreco_id,
              condicaopagamentoid: parsedData.condicaoPagamento.condicaopagamentoid,
            };

            this.$store.commit('InfoPedido/SET_CLIENTE_DATA', {
              clienteData: parsedData,
              enderecoEntrega: parsedData.enderecoEntrega,
              dataCapaPedido: dataCapa,
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Erro',
                text: 'Dados do cliente não encontrados. Por favor, selecione o cliente novamente.',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            });
            return null;
          }
        }

        const alternativo = this.$store.getters['InfoPedido/GET_ENDERECO_ALTERNATIVO'];
        if (alternativo) {
          enderecoEntrega = {
            ufid: alternativo.uf,
            clienteenderecocidade: alternativo.cidade,
          };
        }
        this.impostoLoading = true;
        const { data: resp } = await axios.post('imposto/simular', {
          estabelecimentoid: clienteData.estabelecimento.estabelecimentoid,
          clienteId: clienteData.cliente?.clienteid,
          clienteNomeAbreviado: clienteData.cliente.clientenomeabreviado || clienteData.cliente.clientenomematriz || clienteData.cliente.clienteiderp || clienteData.cliente.clienteIderp,
          naturezaOperacaoId: selecionarNaturezaFiscal(clienteData, { endereco: enderecoEntrega }),
          canalVendaId: clienteData.canalVenda?.canal_venda_id || '',
          itemId: newItem.item_id,
          quantidade: newItem.valor,
          precoUnitario: this.item.item_price,
          ufDs: enderecoEntrega.ufid,
          cidadeDs: enderecoEntrega.clienteenderecocidade,
          contribuinteIcms: dataCapa.clienteisentoie ? 0 : 1,
          tabelaPrecoId: dataCapa.tabelaprecoid,
          condicaoPagamentoId: dataCapa.condicaopagamentoid,
        });

        if (resp?.data) {
          // Pedido de doação (WD): usa d-preco-doacao quando disponível.
          const dataImposto = aplicarPrecoDoacao(resp.data, isPedidoDoacao(clienteData), getTipoPedidoAtual());
          return {
            precoComImposto: precoFinalSimulado(dataImposto),
            precoBruto: dataImposto.precoComImposto || 0,
            baseIcms: dataImposto.baseIcms || 0,
            valorIcms: dataImposto.valorIcms || 0,
            naturezaoperacaoidimposto: dataImposto.naturezaOperacao || 0,
          };
        }

        return null;
      } catch (error) {
        console.error('Erro ao fazer a chamada à API:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao calcular impostos',
          timer: 2000,
        });
        return null;
      } finally {
        this.impostoLoading = false;
      }
    },
    getUserId() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData'));
        return userData?.id || userData?.userData?.id || 'default';
      } catch (error) {
        console.error('Erro ao obter ID do usuário:', error);
        return 'default';
      }
    },
  },
  mounted() {
    this.$root.$on('pic:items-added', this.onPicItemsAdded);
    this.$root.$on('info-pedido:updated', this.onInfoPedidoUpdated);
  },
  beforeDestroy() {
    this.$root.$off('pic:items-added', this.onPicItemsAdded);
    this.pricingRequestId += 1;
    this.$root.$off('info-pedido:updated', this.onInfoPedidoUpdated);
  },
};
</script>

<template>
  <b-modal
    id="modal-top-selected-embalagens"
    ref="refModalTopSelectedEmbalagens"
    size="lg"
    hide-footer
    title="Adicionar Produto"
    modal-class="modal-add-product"
    @ok="onSelectedEmbalagem"
    @show="onSelectedEmbalagem"
    @hidden="onModalHidden"
    no-close-on-backdrop
  >
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="height: 300px;">
      <b-spinner variant="primary" label="Carregando..."></b-spinner>
    </div>

    <div v-else class="modal-content-wrapper px-3 py-2">
      <!-- Client Info Bar -->
      <div v-if="GET_CLIENTE_DATA && GET_CLIENTE_DATA.cliente" class="client-info-bar">
        <div class="client-info">
          <feather-icon icon="UserIcon" size="16" />
          <div class="info-content">
            <span class="label">CLIENTE</span>
            <span class="value">{{ GET_CLIENTE_DATA.cliente.clientenomeabreviado || 'Cliente' }}</span>
          </div>
        </div>

        <div class="order-info">
          <!-- Chip TABELA removido a pedido do cliente -->
          <div class="info-item">
            <feather-icon icon="ShoppingCartIcon" size="16" />
            <div class="info-content">
               <span class="label">ITENS</span>
               <span class="value">{{ itemsCarrinho.length }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Barra preta de ESTOQUE/PREÇO removida a pedido do cliente (as infos
           detalhadas continuam no corpo do produto abaixo). O fetch do preview
           segue ativo pois impostoPreview alimenta o detalhe do produto. -->
      <e-commerce-product-details
        v-if="getInfoItem.dataItensPedido && getInfoItem.dataItensPedido.item_id"
        :json="gradeAtual"
        :product="getInfoItem.dataItensPedido"
        :imposto-preview="impostoPreview"
        require-calculated-price
        :calculated-price-ready="precoCalculadoAtualValido"
        :calculated-effective-price="pricingState.effectivePrice"
        :calculated-price-loading="pricingState.status === 'loading' || adicionarLoading"
        :calculated-price-message="pricingState.message"
        is-modal
        v-model="getInfoItem.dataItensPedido.gradeItem"
        @remove-item="handleRemoveItem"
        @update:grade="updatedGrade"
        @calcular-imposto="calcularImposto"
        @retry-calculated-price="retryPricing"
        @confirmar="adicionarCarrinho"
      />
      <div
        v-else
        class="d-flex flex-column align-items-center justify-content-center text-center"
        style="min-height: 220px; padding: 1.5rem;"
      >
        <feather-icon icon="AlertCircleIcon" size="40" class="text-warning mb-1" />
        <h5 class="mb-50">Produto sem cadastro completo</h5>
        <p class="text-muted mb-0" style="max-width: 380px;">
          Este item ainda não possui preço cadastrado na tabela
          <strong>{{ (GET_DATA_CAPA_PEDIDO && GET_DATA_CAPA_PEDIDO.tabelaprecoid) || '—' }}</strong>
          ou não está vinculado à categoria selecionada. Contate o ADM Vendas
          ou digite o produto manualmente em "Pedidos de Venda".
        </p>
      </div>

      <pic-oferta-inline
        v-if="show && $store.getters['preferencias/picAtivo'] === true && getInfoItem.dataItensPedido && getInfoItem.dataItensPedido.item_id"
        :item="{ item_id: getInfoItem.dataItensPedido.item_id }"
        :context="pedidoContextPic"
        @use-pic="usarPic"
      />

      <div class="modal-actions-footer">
        <div class="items-summary" v-if="itemsCarrinho.length > 0">
          <span class="summary-count">{{ itemsCarrinho.length }} item(s)</span>
          <span class="summary-separator">|</span>
          <span class="text-muted">{{ valorDeCustoVisual ? 'Valor de custo:' : 'Valor:' }}</span>
          <span class="summary-total">{{ totalVisualCarrinho === null ? '—' : totalVisualCarrinho.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
        </div>
        <div class="actions-buttons ml-auto">
           <b-button variant="outline-secondary" @click="onCancelModal">
             <feather-icon icon="XIcon" size="16" class="mr-50" />
             Cancelar
           </b-button>
        </div>
      </div>
    </div>

  </b-modal>
</template>

<style scoped lang="scss">
.modal-add-product {
  --map-primary: var(--sf-accent, #2563eb);
}

.client-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--sf-accent, #2563eb);
  color: white;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;

  .client-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    feather-icon {
      opacity: 0.9;
    }
  }

  .order-info {
    display: flex;
    gap: 1.5rem;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .info-content {
    display: flex;
    flex-direction: column;
    line-height: 1.1;

    .label {
      font-size: 0.65rem;
      opacity: 0.8;
      text-transform: uppercase;
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .value {
      font-size: 0.85rem;
      font-weight: 600;
      color: white;
    }
  }
}

.modal-actions-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--sf-border-color, #e2e8f0);

  .items-summary {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: var(--sf-surface-secondary, #f8fafc);
    border-radius: 6px;

    .summary-count {
      font-weight: 600;
      color: var(--sf-accent, #2563eb);
      font-size: 0.9rem;
    }

    .summary-separator {
      color: var(--sf-border-color, #cbd5e1);
    }

    .summary-total {
      font-weight: 600;
      color: var(--sf-text-primary, #334155);
    }
  }

  .actions-buttons {
    display: flex;
    gap: 0.75rem;
  }
}

:global(body.dark-layout) {
  .client-info-bar {
    background: var(--sf-accent-dark, #5e50ee);
  }
}

.totvs-preview-bar {
  display: flex;
  gap: 1rem;
  padding: 0.6rem 0.85rem;
  margin: -0.75rem 0 1rem;
  background: var(--sf-surface-secondary, #f8fafc);
  border: 1px solid var(--sf-border-color, #e2e8f0);
  border-radius: 6px;

  .preview-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
  }

  .info-content {
    display: flex;
    flex-direction: column;
    line-height: 1.15;

    .label {
      font-size: 0.62rem;
      opacity: 0.7;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      font-weight: 500;
    }
    .value {
      font-size: 0.88rem;
      font-weight: 600;
      color: var(--sf-text-primary, #334155);
    }
  }
}
</style>
